import React from "react";
import { TFooterComponent } from "../../@types/component/TFooterComponent";

import {
  Container,
  H3,
  ResponsiveContainer,
  SocialContainer,
  SocialCircle,
  Icon,
  P,
  InfoContainer,
  TopContainer,
  PartnerLogo,
} from "./styles";

const Footer: React.FC<TFooterComponent> = ({
  logo,
  partnerName,
  socialNetworks,
  ...rest
}) => {
  return (
    <Container {...rest}>
      <TopContainer>
        <ResponsiveContainer>
          {logo ? <PartnerLogo img={logo} /> : <H3>{partnerName}</H3>}
          <SocialContainer>
            {socialNetworks?.instagram && (
              <SocialCircle
                id="btn-instagram"
                onClick={() => window.open(socialNetworks?.instagram, "_blank")}
              >
                <Icon id="instagram" name="instagram" />
              </SocialCircle>
            )}
            {socialNetworks?.facebook && (
              <SocialCircle
                id="btn-facebook"
                onClick={() => window.open(socialNetworks?.facebook, "_blank")}
              >
                <Icon id="facebook" name="facebook" />
              </SocialCircle>
            )}
            {socialNetworks?.youtube && (
              <SocialCircle
                id="btn-youtube"
                onClick={() => window.open(socialNetworks?.youtube, "_blank")}
              >
                <Icon id="youtube" name="youtube" />
              </SocialCircle>
            )}
          </SocialContainer>
        </ResponsiveContainer>
      </TopContainer>
      <InfoContainer>
        <ResponsiveContainer>
          <P>88i Seguradora Digital S.A.</P>
          <P>Processo Susep nº 15414.618702/2020-10.</P>
        </ResponsiveContainer>
      </InfoContainer>
    </Container>
  );
};

export default Footer;
